import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import { getCallableErrorMessage } from '../../utils/serviceErrorMessage';

/**
 * Sends Google review request via Cloud Function + Nodemailer (not EmailJS consent template).
 */
export async function sendReviewRequestEmail({
  to,
  patientName,
  clinicName,
  reviewPageUrl,
  clinicId,
  consentId,
  sentByName,
  sentByUserId,
  emailSource,
}) {
  const email = String(to || '').trim();
  if (!email) throw new Error('Patient email is required.');
  if (!clinicId) throw new Error('Clinic ID is required.');
  if (!consentId) throw new Error('Consent ID is required.');

  const sendFn = httpsCallable(functions, 'sendGoogleReviewRequest');
  try {
    const result = await sendFn({
      to: email,
      patientName: patientName || 'Patient',
      clinicName: clinicName || 'Your dental practice',
      reviewPageUrl,
      clinicId,
      consentId,
      ...(sentByName ? { sentByName } : {}),
      ...(sentByUserId ? { sentByUserId } : {}),
      ...(emailSource ? { emailSource } : {}),
    });
    return result.data || { success: true, to: email };
  } catch (error) {
    throw new Error(getCallableErrorMessage(error) || 'Failed to send review request email.');
  }
}
